var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "main-body"
  }, [_c('h1', {
    staticStyle: {
      "padding-bottom": "12px"
    }
  }, [_vm._v("登陆")]), _c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "手机号",
      "prop": "mobile"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入手机号"
    },
    model: {
      value: _vm.formItem.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "mobile", $$v);
      },
      expression: "formItem.mobile"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "输入密码"
    },
    on: {
      "on-enter": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    },
    model: {
      value: _vm.formItem.password,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "password", $$v);
      },
      expression: "formItem.password"
    }
  })], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("登陆")])], 1)], 1), _c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('a', [_vm._v("没有账号？点击注册")])])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }